import './Global.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import About from './Components/About'
import Service from './Components/Service'
import Benefits from './Components/Benefits'
import Infos from './Components/Infos'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
import ScrollButton from './Components/ScrollButton'
import Header from './Components/Header'
import Companies from './Components/Companies'

function App() {
  return (
    <>
      <Header />
      <main className="app-main">
        <About />
        <Companies />
        <Service />
        <Benefits />
        <Infos />
        <Contact />
      </main>
      <footer>
        <Footer />
      </footer>
      <ScrollButton />
    </>
  )
}

export default App
